const style = {
    cardBorder: {
        display: "flex",
        justifyContent: "center"
    },
    title: {
        margin: "5px"
    },
    imageBorder: {
        margin: "20px 10px 20px 10px",
    },
    image: {
        height: "300px",
        borderRadius: "25px"
    }
}

export default style;